import classNames from 'classnames';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

/**
 * The bottom dot indicator. Fixing a rendering problem.
 * @param {(React.MouseEvent | React.KeyboardEvent) => void} clickHandler
 * @param {boolean} isSelected
 * @param {number} index
 * @param {string} label
 * @returns {React.ReactNode}
 */
const RenderImageDot = (clickHandler, isSelected, index, label) => {
	return (
		<li key={index} style={{ display: 'inline-flex' }}>
			<div
				className={classNames('dot', { selected: isSelected })}
				role="button"
				tabIndex="0"
				aria-label={label}
				onClick={clickHandler}
			/>
		</li>
	);
};

/**
 * @typedef {Pick<import('react-responsive-carousel').CarouselProps, 'autoPlay' | 'interval' | 'transitionTime' | 'infiniteLoop' | 'showThumbs'>} ImageSliderProps
 * @typedef ImageSliderOptions
 * @property {import('react-responsive-carousel').CarouselProps['autoPlay']} [autoPlay] A value indicating whether the Carousel scrolls without interaction.
 * @property {import('react-responsive-carousel').CarouselProps['interval']} [interval=3000] The duration on each page, in milliseconds.
 * @property {import('react-responsive-carousel').CarouselProps['transitionTime']} [transitionTime=350] The duration of transition between pages, in milliseconds.
 * @property {import('react-responsive-carousel').CarouselProps['infiniteLoop']} [infiniteLoop] The duration of transition between pages, in milliseconds.
 * @property {import('react-responsive-carousel').CarouselProps['showThumbs']} [showThumbs] A value indicating whether the carousel has thumbs...
 */
/** @type {import('~/types/React').ReactFC<ImageSliderOptions>} */
const ImageSlider = ({ autoPlay, interval = 3000, transitionTime = 350, infiniteLoop, showThumbs, ...rest }) => (
	<Carousel
		{...rest}
		showStatus={false}
		autoPlay={autoPlay}
		interval={interval}
		transitionTime={transitionTime}
		infiniteLoop={infiniteLoop}
		renderIndicator={RenderImageDot}
		showThumbs={showThumbs}
	>
		{rest.children}
	</Carousel>
);

export default ImageSlider;
